import { render, staticRenderFns } from "./ProductWindows3.vue?vue&type=template&id=2f9a87e5&scoped=true&"
import script from "./ProductWindows3.vue?vue&type=script&lang=js&"
export * from "./ProductWindows3.vue?vue&type=script&lang=js&"
import style0 from "./ProductWindows3.vue?vue&type=style&index=0&id=2f9a87e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9a87e5",
  null
  
)

export default component.exports